import acolhimentoSaudeBucalRepository from './acolhimentoSaudeBucalRepository'
import acolhimentoAcsTacsRepository from './acolhimentoAcsTacsRepository'
import agendamentoRepository from './agendamentoRepository'
import agendamentoRetroativoRepository from './agendamentoRetroativoRepository'
import alteracaoConsultasFinalizadasRepository from './alteracaoConsultasFinalizadasRepository'
import atendimentoRepository from './atendimentoRepository'
import chamadaRepository from './chamadaRepository'
import fechamentoConsultaRepository from './fechamentoConsultaRepository'
import filaRepository from './filaRepository'
import gerenciamentoDiarioRepository from './gerenciamentoDiarioRepository'
import gerenciamentoMedicoRepository from './gerenciamentoMedicoRepository'
import impressaoRepository from './impressaoRepository'
import jornadaBloqueioRepository from './jornadaBloqueioRepository'
import jornadaRepository from './jornadaRepository'
import jornadaSituacaoRepository from './jornadaSituacaoRepository'
import listagemConsultaAgendadaRealizadaRepository from './listagemConsultaAgendadaRealizadaRepository'
import parametrizacaoRepository from './parametrizacaoRepository'
import atendimentoEnfermagemRepository from './atendimentoEnfermagemRepository'
import recepcaoRepository from './recepcaoRepository'
import relatorioConsultaFinalizadaRepository from './relatorioConsultaFinalizadaRepository'
import relatorioConsultaSolicitadaRepository from './relatorioConsultaSolicitadaRepository'
import relatorioEstatisticoConsultaRepository from './relatorioEstatisticoConsultaRepository'
import relatorioEstatisticoPacienteRepository from './relatorioEstatisticoPacienteRepository'
import relatorioEstatisticoStatusRepository from './relatorioEstatisticoStatusRepository'
import relatorioIdentificacaoRepository from './relatorioIdentificacaoRepository'
import relatorioJornadaRepository from './relatorioJornadaRepository'
import relatorioPacienteAtendimentoRepository from './relatorioPacienteAtendimentoRepository'
import relatorioProcedimentoLancadoPeriodoRepository from './relatorioProcedimentoLancadoPeriodoRepository'
import relatorioProcedimentoRepository from './relatorioProcedimentoRepository'
import relatorioProducaoAmbulatorialRepository from './relatorioProducaoAmbulatorialRepository'
import relatorioQuantitativoAtendimentoRepository from './relatorioQuantitativoAtendimentoRepository'
import relatorioQuantitativoCidRepository from './relatorioQuantitativoCidRepository'
import relatorioQuantitativoConsultaSolicitadaRepository from './relatorioQuantitativoConsultaSolicitadaRepository'
import relatorioQuantitativoProcedimentoRepository from './relatorioQuantitativoProcedimentoRepository'
import relatorioQuantitativoProducaoRepository from './relatorioQuantitativoProducaoRepository'
import servicoRepository from './servicoRepository'
import supervisorRepository from './supervisorRepository'
import historicoAtendimentoRepository from './historicoAtendimentoRepository'
import formularioRaasRepository from './formularioRaasRepository'
import assinaturaEletronicaRepository from './assinaturaEletronicaRepository'
import relatorioRastreioFeridaRepository from './relatorioRastreioFeridaRepository'
import relatorioCancelamentoRepository from './relatorioCancelamentoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/ambulatorio`

    return {
        acolhimentoSaudeBucal: acolhimentoSaudeBucalRepository(baseUrl),
        acolhimentoAcsTacs: acolhimentoAcsTacsRepository(baseUrl),
        agendamento: agendamentoRepository(baseUrl),
        agendamentoRetroativo: agendamentoRetroativoRepository(baseUrl),
        alteracaoConsultasFinalizadas: alteracaoConsultasFinalizadasRepository(baseUrl),
        atendimento: atendimentoRepository(baseUrl),
        chamada: chamadaRepository(baseUrl),
        fechamentoConsulta: fechamentoConsultaRepository(baseUrl),
        fila: filaRepository(baseUrl),
        gerenciamentoDiario: gerenciamentoDiarioRepository(baseUrl),
        gerenciamentoMedico: gerenciamentoMedicoRepository(baseUrl),
        impressao: impressaoRepository(baseUrl),
        jornada: jornadaRepository(baseUrl),
        jornadaBloqueio: jornadaBloqueioRepository(baseUrl),
        jornadaSituacao: jornadaSituacaoRepository(baseUrl),
        listagemConsultaAgendadaRealizada: listagemConsultaAgendadaRealizadaRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        atendimentoEnfermagem: atendimentoEnfermagemRepository(baseUrl),
        recepcao: recepcaoRepository(baseUrl),
        relatorioConsultaFinalizada: relatorioConsultaFinalizadaRepository(baseUrl),
        relatorioConsultaSolicitada: relatorioConsultaSolicitadaRepository(baseUrl),
        relatorioEstatisticoConsulta: relatorioEstatisticoConsultaRepository(baseUrl),
        relatorioEstatisticoPaciente: relatorioEstatisticoPacienteRepository(baseUrl),
        relatorioEstatisticoStatus: relatorioEstatisticoStatusRepository(baseUrl),
        relatorioIdentificacao: relatorioIdentificacaoRepository(baseUrl),
        relatorioJornada: relatorioJornadaRepository(baseUrl),
        relatorioPacienteAtendimento: relatorioPacienteAtendimentoRepository(baseUrl),
        relatorioProcedimento: relatorioProcedimentoRepository(baseUrl),
        relatorioProcedimentoLancadoPeriodo: relatorioProcedimentoLancadoPeriodoRepository(baseUrl),
        relatorioProducaoAmbulatorial: relatorioProducaoAmbulatorialRepository(baseUrl),
        relatorioQuantitativoAtendimento: relatorioQuantitativoAtendimentoRepository(baseUrl),
        relatorioQuantitativoCid: relatorioQuantitativoCidRepository(baseUrl),
        relatorioQuantitativoConsultaSolicitada: relatorioQuantitativoConsultaSolicitadaRepository(baseUrl),
        relatorioQuantitativoProcedimento: relatorioQuantitativoProcedimentoRepository(baseUrl),
        relatorioQuantitativoProducao: relatorioQuantitativoProducaoRepository(baseUrl),
        servico: servicoRepository(baseUrl),
        supervisor: supervisorRepository(baseUrl),
        historicoAtendimento: historicoAtendimentoRepository(baseUrl),
        formularioRaas: formularioRaasRepository(baseUrl),
        assinaturaEletronica: assinaturaEletronicaRepository(baseUrl),
        relatorioRastreioFerida: relatorioRastreioFeridaRepository(baseUrl),
        relatorioCancelamento: relatorioCancelamentoRepository(baseUrl),
    }
}
